import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationContentBlockerFunctionLastEditorsGet = {
    path: "/template/content-blocker/functions/last-editors",
    method: ERouteHttpVerb.GET
};
export { routeLocationContentBlockerFunctionLastEditorsGet };
